
import React, { useState, useEffect } from 'react';
import creditLogo from "../../../assets/images/creditLogo.png";
import myfreescorenowLogo from "../../../assets/images/myfreescorenowLogo.png";
import { Box, Button, Divider, Grid, Card, Typography, useMediaQuery, CardContent, Container, TableContainer, Table, TableBody, Paper, TableCell, TableHead, TableRow, CardActionArea } from '@mui/material';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import advisorhub from "../../../assets/images/advisorhub.png";
import { postData } from '../../../redux/apiSlice';
import { useDispatch } from 'react-redux';
import { fetchData } from '../../../redux/apiSlice';
import config from '../../../AppConfig';
import AuthUser from '../../../Components/Auth/AuthUser';
import Backdrop from '@mui/material/Backdrop';
import Freez from '../../../Components/Loader/Loader';
import formatPhoneNumber from '../../../Components/Formats/PhoneNumberValidation';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Loader from '../../../Components/Loader/Loader';

function getAriaValueText(value) {
    return `${value}`;
}
function FundingShotPdf(props) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [cobrandLogo, setCobrandLogo] = useState(null);
    const dispatch = useDispatch();
    const [data, setData] = useState(null);
    const [freez, setFreez] = React.useState(false);
     const { http, user } = AuthUser();
     const [email,setEmail] = useState([]);
     const [aid,setAid] = useState();
    const [phone, setPhone] = useState([]);
    const [showLogo, setShowLogo] = useState(false);
      const [isLoading, setIsLoading] = useState(false);
      const [error, setError] = React.useState('');
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    
    const CustomSlider = styled(Slider)({
        color: '#9C9FA9', // blue for the filled track
        height: isMobile ? 5 : 6,
        '& .MuiSlider-track': {
            backgroundColor: '#00A4CB',
            border: 'none',
        },
        '& .MuiSlider-rail': {
            backgroundColor: '#9C9FA9', // gray for the unfilled track
            opacity: 1,
        },
        '& .MuiSlider-thumb': {
            height: isMobile ? 15 : 24,
            width: isMobile ? 15 : 24,
            backgroundColor: '#fff', // dark blue thumb
            border: isMobile ? '5px solid #034B94' : '6px solid #034B94',
            boxShadow: 'none',
            '&:hover': {
                boxShadow: '0 0 0 8px rgba(0, 63, 136, 0.16)',
            },
            '&::before': {
                display: 'none',
            },
        },
        '& .MuiSlider-markLabel': {

            color: '#000',
            fontWeight: 'normal',
        },
        '& .MuiSlider-markLabel[data-index="0"], & .MuiSlider-markLabel[data-index="3"]': {
            fontWeight: 'bold',
            fontSize: isMobile ? "10px" : '14px',
            marginTop: isMobile ? '-10px' : '0px',
        },
        '& .MuiSlider-markLabel[data-index="1"], & .MuiSlider-markLabel[data-index="2"]': {
            color: '#197B1F',
            // fontSize: isMobile ? "6px" : '10px',
            marginTop: isMobile ? '0' : '0px',
        },
    });
    useEffect(()=>{
         const pathname = window.location.pathname;
         const parts = pathname.split('/');
         const email = atob(parts[2]);
         const password = atob(parts[3]);
         setAid(atob(parts[4]));
         const phone_number = atob(parts[5]);
        //  alert(password);
       getEpicProData(email,password,atob(parts[4]),phone_number);
       getAidDetails();
       },[aid]);


        const checkImpruvu = async()=>{
            const apiUrl = '/fetchCompanyAIDList/4284';
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            if(res){
                if(res.aidList.includes(aid)){
                    setShowLogo(true);
                }
                
            }
        }
    useEffect(()=>{
        checkImpruvu();

    },[aid])
    const getEpicProData = async (email, password,aid,phone_number) => {
        handleFreezStart();
        const apiUrl = '/fundingShot3BReport';
        // const args = { username: "john.smith@yopmail.com",
        //     //  password: "Credit@2023",
        
        //       aid:aid,
        //       phone_number:phone_number}
        const args = { username: email, password: password, aid:aid,phone_number:phone_number};
        // console.log("username",email,password)
        try {
          const response = await http.post(apiUrl, args);
          if (response && response.data && response.data.success) {
            handleFreezStop();
            const result = response.data.data; 
            
            setData(result);
            setEmail(email);
            setPhone(phone_number);
         
          }
          else {
            handleFreezStop();
            setIsLoading(false)
            setError(response.data.error)
        }
        } catch (error) {
            handleFreezStop();
            setIsLoading(false)
          if (error.response) {
            setError(error.response.data.error || 'No Funding Shot Report Available')
          } else {
            setError('Something went wrong')
          }
        }
      };
      
      
    const aidId = "363128FT";
    const getAidDetails = async () => {
            const apiUrl = "/getCreditSnapShotComapny/details/"+aid;
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            if(res){
                    setCobrandLogo(res.companyLogo);
            }
        }

    

    const minVal = data?.minValue || 9800;
    const maxVal = data?.maxValue || 18800;

    const marks = [
        {
            value: 0,
            label: '$0',
        },
        {
            value: 20,
            // value: minVal,
            label: (
                <span style={{
                    fontSize: isMobile ? 'medium' : 'large',
                    color: '#197B1F',
                    // position: 'relative',
                    // top: isMobile ? '-10px' : '0'
                  }}><b>${new Intl.NumberFormat().format(minVal)}</b></span>
            ),
        },
        {
            value: 47,
            // value: maxVal,
            label:(<span style={{
                fontSize: isMobile ? 'medium' : 'large',
                color: '#197B1F',
                // position: 'relative',
                // top: isMobile ? '10px' : '0'
              }}>
                <b>${new Intl.NumberFormat().format(maxVal)}</b>
              </span>),
        },
        {
            value: 100,
            label: '$750,000',
        },
    ];
   
    return (
        <>
        {
          
           data? 
           <>
           
            <Grid container item lg={12} md={12} sm={12} xs={12} p={2} className="fundingShotbg" sx={{ display: "flex", justifyContent: "space-between", }}>
                <Grid item lg={6} md={6} sm={6} xs={6}>
                    <img alt="#"
                        src={config.BACKEND_URL + 'images/companyLogo/' + cobrandLogo}
                        style={{ height: isMobile ? "42px" : "65px" }} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}>
                    <Typography sx={{ color: "#6D6666", fontSize: isMobile ? "9px" : "12px", gap: 1, fontWeight: 530 }}>
                        Powered By &nbsp;
                        {/* <Link to='/'> */}
                        <img
                            alt="Logo"
                            src={myfreescorenowLogo}
                            style={{ verticalAlign: 'middle', height: isMobile ? "40px" : "65px" }}
                        />
                        {/* </Link> */}
                    </Typography>
                </Grid>
            </Grid>
            <Box mt={2}>
                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: "#E5F0FF", padding: "1% 7% 1% 7%", }}>
                    <Card sx={{ backgroundColor: "white", width: "100%", boxShadow: "none", borderRadius: "7px" }}>
                        {data.eligible === true ? 
                        <>
                        <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center" mt={isMobile ? 2 : 1}>
                            {/* <Typography fontWeight="bold" variant={isMobile ? 'body2' : 'h5'} textAlign="center">Your client, {data.BorrowerName} has been pre approved for <span style={{ fontSize: isMobile ? "15px" : "20px" }}>{data ? `$${new Intl.NumberFormat().format(data.minValue)}` : '$9,800'} - {data ? `$${new Intl.NumberFormat().format(data.maxValue)}` : '$9,800'} </span> Business Funding.</Typography> */}
                            <Typography fontWeight="bold" variant={isMobile ? 'body2' : 'h5'} textAlign="center" color={"#0C8D13"}>{data.BorrowerName}'s Business Funding Eligibility Estimate is <span style={{ fontSize: isMobile ? "15px" : "x-large" }}><b>{data ? `$${new Intl.NumberFormat().format(data.minValue)}` : '$9,800'}</b> to <b>{data ? `$${new Intl.NumberFormat().format(data.maxValue)}` : '$9,800'} </b></span>
                            </Typography>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center" >
                            <Box sx={{ width: isMobile ? 300 : 900 }}>
                                <CustomSlider
                                    getAriaLabel={() => 'Value range'}
                                    getAriaValueText={getAriaValueText}
                                    defaultValue={[20, 47]}
                                    // value={[minVal, maxVal]} // You can use defaultValue if it's static
                                    // min={0}
                                    // max={750000}
                                    valueLabelDisplay="auto"
                                    marks={marks}
                                    disabled
                                />
                            </Box>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center" mt={1} >
                            <Typography fontWeight="bold" variant={isMobile?"body2":'body1'} textAlign="center" color={"#3B3D3B"}> Please Contact Your Funding Partner For More Information.
                            </Typography>
                        </Grid>
                        </>
                        :
                        <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center" mt={isMobile ? 2 : 1}>
                            <Typography fontWeight="bold" color="#FF0808" variant={isMobile ? 'body2' : 'h5'} textAlign="center">The Funding Eligibility Can Not be Computed Based On The Current Data. <br /> Please Contact Your Funding Partner For More Information.
                            </Typography>
                            
                            {/* <Typography fontWeight="bold" color="#FF7121" variant={isMobile ? 'body2' : 'h5'} textAlign="center">Your client, {data.BorrowerName} may be eligible for <span style={{ fontSize: isMobile ? "15px" : "20px" }}>{data ? `$${new Intl.NumberFormat().format(data.minValue)}` : '$9,800'} - {data ? `$${new Intl.NumberFormat().format(data.maxValue)}` : '$9,800'} </span> Business Funding.<br/>
                            <span style={{color:"black", fontSize:isMobile?"11px":"20px"}}> Contact your funding partner for more details.</span></Typography> */}
                        </Grid>
                        }
                        
                    </Card>
                    {/* <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center">
                        <Typography color="#108717" fontWeight="bold" variant={isMobile ? 'body1' : 'h6'}>Your Potential Commission: {`$${new Intl.NumberFormat().format(data ? data.minValueCommission : 0)}`} - {`$${new Intl.NumberFormat().format(data ? data.maxValueCommission : 0)}`}</Typography>
                    </Grid> */}
                </Grid>
                <Container minWidth={isMobile ? "100%" : 360}>
                    <Box p={2}>
                        <Card sx={{ backgroundColor: "#C5DDFF" }} mt={2} p={1}>
                            <CardContent sx={{ paddingBottom: "17px !important" }}>
                                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2}>
                                    <Grid item lg={3} md={3} sm={12} xs={12} display="flex" justifyContent="center" alignItems="center">
                                        <Typography fontWeight="bold">Vantage Score® 3.0 Credit Score</Typography>
                                    </Grid>
                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} className='reportScoreBoxContainer' >
                                            <Grid item lg={6} md={6} sm={6} xs={6} display="flex" justifyContent="center" className='reportScoreBox bg-transunion'>TransUnion®</Grid>
                                            <Grid item lg={6} md={6} sm={6} xs={6} display="flex" justifyContent="center" className='reportScoreText'>{data.RiskScore ? data.RiskScore.TUC : "607"}</Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} className='reportScoreBoxContainer'>
                                            <Grid item lg={6} md={6} sm={6} xs={6} display="flex" justifyContent="center" className='reportScoreBox bg-experian'>Experian®</Grid>
                                            <Grid item lg={6} md={6} sm={6} xs={6} display="flex" justifyContent="center" className='reportScoreText'>{data.RiskScore ? data.RiskScore.EXP : "568"}</Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item lg={3} md={3} sm={12} xs={12}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} className='reportScoreBoxContainer'>
                                            <Grid item lg={6} md={6} sm={6} xs={6} display="flex" justifyContent="center" className='reportScoreBox bg-equifax'>Equifax®</Grid>
                                            <Grid item lg={6} md={6} sm={6} xs={6} display="flex" justifyContent="center" className='reportScoreText'>{data.RiskScore ? data.RiskScore.EQF : "554"}</Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: "#C5DDFF" }} mt={2} p={1}>
                            <Typography color="#0F0396" fontWeight="bold">Personal Information</Typography>
                        </Grid>
                        <Card sx={{ borderRadius: "0px", backgroundColor: "#F0EBEB", mt: 2, p: 1 }}>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                    <Typography><b>Name :</b> {data ? data.BorrowerName : "John Smith"}</Typography>
                                </Grid>
                                <Grid item lg={4} md={4} sm={12} xs={12} textAlign={isMobile ? "left" : "center"}>
                                    <Typography><b>Phone Number: </b>{phone?formatPhoneNumber(phone):"(555)-555 1222"}</Typography>
                                </Grid>
                                <Grid item lg={4} md={4} sm={12} xs={12} textAlign={isMobile ? "left" : "right"}>
                                    <Typography><b>Email:</b> {email?email: "Johnsmith111@gmail.com"}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="space-between" sx={{ borderTop: "1px solid black", mt: 1 }}>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Typography><b>Address:</b>{data ? data.Address : ""}</Typography>
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12} textAlign={isMobile ? "left" : "right"}>
                                    <Typography><b>Employer Name :</b> {data ? data.Employer : ""}</Typography>
                                </Grid>
                            </Grid>
                        </Card>
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: "#C5DDFF" }} mt={2} p={1}>
                            <Typography color="#0F0396" fontWeight="bold">Profile Summary</Typography>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                            <Box width="100%" sx={{ backgroundColor: "#F0EBEB", borderRadius: "7px" }} >
                                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} p={1}>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Card sx={{ backgroundColor: "white", boxShadow: "none" }} >
                                            <Grid container item lg={12} md={12} sm={12} xs={12} p={2}
                                                sx={{ display: "flex", justifyContent: "space-between" }}>
                                                <Grid item lg={6} md={6} sm={8} xs={8}>
                                                    <Typography fontWeight="bold" display="flex" alignItems="center"><span>
                                                        <img alt="#" src={require("../../../assets/images/totalAccount.png")}
                                                            style={{ width: "25px", marginRight: "8px" }} /></span>
                                                        Total Accounts</Typography>
                                                </Grid>
                                                <Grid item lg={6} md={6} sm={4} xs={4} sx={{ textAlign: "right" }}>
                                                    <Typography>{data ? data.TotalAccCount : 0}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Card sx={{ backgroundColor: "white", boxShadow: "none" }}>
                                            <Grid container item lg={12} md={12} sm={12} xs={12} p={2}
                                                sx={{ display: "flex", justifyContent: "space-between" }}>
                                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                                    <Typography fontWeight="bold" display="flex" alignItems="center">
                                                        <span>
                                                            <img alt="#" src={require("../../../assets/images/tradline.png")}
                                                                style={{ width: "25px", marginRight: "8px" }} /></span>
                                                        Tradelines with Historical Negatives</Typography>
                                                </Grid>
                                                <Grid item lg={4} md={4} sm={4} xs={4} sx={{ textAlign: "right" }}>
                                                    <Typography>{data ? data.Negative : 0}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} p={1}>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Card sx={{ backgroundColor: "white", boxShadow: "none" }} >
                                            <Grid container item lg={12} md={12} sm={12} xs={12} p={2}
                                                sx={{ display: "flex", justifyContent: "space-between" }}>
                                                <Grid item lg={6} md={6} sm={8} xs={8}>
                                                    <Typography fontWeight="bold" display="flex" alignItems="center">
                                                        <span>
                                                            <img alt="#" src={require("../../../assets/images/totalCredit.png")}
                                                                style={{ width: "25px", marginRight: "8px" }} /></span>
                                                        Total Available Credit</Typography>
                                                </Grid>
                                                <Grid item lg={6} md={6} sm={4} xs={4} sx={{ textAlign: "right" }}>
                                                    <Typography>{`$${new Intl.NumberFormat().format(data ? data.totalCreditAvailable : 0)}`}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Card sx={{ backgroundColor: "white", boxShadow: "none" }} >
                                            <Grid container item lg={12} md={12} sm={12} xs={12} p={2}>
                                                <Grid item lg={6} md={6} sm={8} xs={8}
                                                    sx={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Typography fontWeight="bold" display="flex" alignItems="center"><span>
                                                        <img alt="#" src={require("../../../assets/images/average.png")}
                                                            style={{ width: "25px", marginRight: "8px" }} /></span>Average Age of Accounts</Typography>
                                                </Grid>
                                                <Grid item lg={6} md={6} sm={4} xs={4} sx={{ textAlign: "right" }}>
                                                    <Typography>{data ? data.differenceDays : 0}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} p={1}>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Card sx={{ backgroundColor: "white", boxShadow: "none" }}>
                                            <Grid container item lg={12} md={12} sm={12} xs={12} p={2}>
                                                <Grid item lg={6} md={6} sm={8} xs={8}
                                                    sx={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Typography fontWeight="bold" display="flex" alignItems="center"><span>
                                                        <img alt="#" src={require("../../../assets/images/hightestcredit.png")}
                                                            style={{ width: "25px", marginRight: "8px" }} /></span>Highest Tradeline Limit</Typography>
                                                </Grid>
                                                <Grid item lg={6} md={6} sm={4} xs={4} sx={{ textAlign: "right" }}>
                                                    <Typography>{`$${new Intl.NumberFormat().format(data ? data.highLimitAmount : 0)}`}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <Card sx={{ backgroundColor: "white", boxShadow: "none" }}>
                                            <Grid container item lg={12} md={12} sm={12} xs={12} p={2} >
                                                <Grid item lg={6} md={6} sm={8} xs={8}
                                                    sx={{ display: "flex", justifyContent: "space-between" }}>
                                                    <Typography fontWeight="bold" display="flex" alignItems="center"><span>
                                                        <img alt="#" src={require("../../../assets/images/inquires.png")}
                                                            style={{ width: "25px", marginRight: "8px" }} /></span>Inquiries</Typography>
                                                </Grid>
                                                <Grid item lg={6} md={6} sm={4} xs={4} sx={{ textAlign: "right" }}>
                                                    <Typography>{data ? data.Inquiries : 0}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: "#C5DDFF" }} mt={1} p={1}>
                            <Typography color="#0F0396" fontWeight="bold">Debt Utilization</Typography>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                            <Card sx={{ backgroundColor: "#F0EBEB", width: "100%", p: 1 }} >
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                    <Card sx={{ backgroundColor: "#EAEDFD", width: "100%", p: 1, mb: 1 }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontWeight="bold" fontSize={isMobile ? "10px" : "16px"}>Summary</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography color='#00A4CB' fontWeight="bold" fontSize={isMobile ? "10px" : "16px"} textAlign={isMobile ? "center" : "left"}>TransUnion</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography color='#034B94' fontWeight="bold" fontSize={isMobile ? "10px" : "16px"} textAlign={isMobile ? "center" : "left"}>Experian</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography color='#951F32' fontWeight="bold" fontSize={isMobile ? "10px" : "16px"} textAlign={isMobile ? "center" : "left"}>Equifax</Typography>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                    <Card sx={{ backgroundColor: "#EDFFE7", width: "100%", p: 1, mb: 1, borderRadius: "0px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontWeight="bold" fontSize={isMobile ? "10px" : "16px"}>Total Credit Limit</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>${data?.creditUtilizationAll?.totalLimit?.TUC}</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>${data?.creditUtilizationAll?.totalLimit?.EXP}</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>${data?.creditUtilizationAll?.totalLimit?.EQF}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                    <Card sx={{ backgroundColor: "#FFE4E4", width: "100%", p: 1, mb: 1, borderRadius: "0px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontWeight="bold" fontSize={isMobile ? "10px" : "16px"}>Total Credit Utilized</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>${data?.creditUtilizationAll?.totalBalance?.TUC}</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>${data?.creditUtilizationAll?.totalBalance?.EXP}</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>${data?.creditUtilizationAll?.totalBalance?.EQF}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                    <Card sx={{ backgroundColor: "#E2FDFF", width: "100%", p: 1, mb: 1, borderRadius: "0px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontWeight="bold" fontSize={isMobile ? "10px" : "16px"}>Total Utilization in %</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontWeight="bold" fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>{data?.creditUtilizationAll?.percentage?.TUC}</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontWeight="bold" fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>{data?.creditUtilizationAll?.percentage?.EXP}</Typography>
                                            </Grid>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography fontWeight="bold" fontSize={isMobile ? "12px" : "16px"} textAlign={isMobile ? "center" : "left"}>{data?.creditUtilizationAll?.percentage?.EQF}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Card>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: "#C5DDFF" }} mt={1} p={1}>
                            <Typography color="#0F0396" fontWeight="bold">Tradelines Summary</Typography>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} spacing={3} alignItems="stretch">
                            <Grid item lg={3} md={3} sm={12} xs={12} display="flex">
                                <Card sx={{
                                    backgroundColor: "#F0EEEE",
                                    borderRadius: "0px",
                                    boxShadow: "none",
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column"
                                }} p={1}>
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography fontWeight="bold">Number of TL over 30%</Typography>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography fontWeight="bold">{data ? data.moreThan30CreditPercentage : 0}</Typography>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item lg={2} md={2} sm={12} xs={12} display="flex">
                                <Card sx={{
                                    backgroundColor: "#F0EEEE",
                                    borderRadius: "0px",
                                    boxShadow: "none",
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column"
                                }} p={1}>
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography fontWeight="bold">Total open TL</Typography>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography fontWeight="bold">{data ? data.openAccounts : 0}</Typography>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item lg={7} md={7} sm={12} xs={12} display="flex">
                                <Card sx={{
                                    backgroundColor: "#F0EEEE",
                                    borderRadius: "0px",
                                    boxShadow: "none",
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column"
                                }} p={1}>
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center">
                                            <Grid item lg={6} md={6} sm={9} xs={9}>
                                                <Typography fontWeight="bold">Total monthly payment</Typography>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={3} xs={3} textAlign="right">
                                                <Typography>${data ? data.totalMonthlyPaymentAmount : 0}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center">
                                            <Grid item lg={6} md={6} sm={9} xs={9}>
                                                <Typography fontWeight="bold">Balance total</Typography>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={3} xs={3} textAlign="right">
                                                <Typography>{`$${new Intl.NumberFormat().format(data ? data.balance : 0)}`}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} display="flex" justifyContent="center">
                                            <Grid item lg={6} md={6} sm={9} xs={9}>
                                                <Typography fontWeight="bold">Total available credit limit (rev)</Typography>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={3} xs={3} textAlign="right">
                                                <Typography>{`$${new Intl.NumberFormat().format(data ? data.creditLimit : 0)}`}</Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: "#C5DDFF" }} mt={1} p={1}>
                            <Typography color="#0F0396" fontWeight="bold">Derogatory Summary</Typography>
                        </Grid>
                        <Card sx={{ boxShadow: "none" }}>
                            <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2}>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Table sx={{ width: "100%" }} aria-label="simple table" size="small">
                                        <TableRow >
                                            <TableCell scope="row" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">Charge offs</Typography></TableCell>
                                            <TableCell align="right" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">{data ? data.chargeOffCount : 0}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell scope="row" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">Collections</Typography></TableCell>
                                            <TableCell align="right" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">{data ? data.collectionCount : 0}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell scope="row" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">Lates</Typography></TableCell>
                                            <TableCell align="right" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">{data ? data.latePayments : 0}</Typography></TableCell>
                                        </TableRow>
                                    </Table>
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Table sx={{ width: "100%" }} aria-label="simple table" size="small">
                                        <TableRow>
                                            <TableCell scope="row" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">Bankruptcy</Typography></TableCell>
                                            <TableCell align="right" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">{data ? data.bankruptcy : 0}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell scope="row" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">Public Records</Typography></TableCell>
                                            <TableCell align="right" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">{data ? data.publicRecords : 0}</Typography></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell scope="row" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">Others</Typography></TableCell>
                                            <TableCell align="right" sx={{ borderBottom: "1px solid #938D8D" }}><Typography fontSize="17px">{data ? data.otherCount : 0}</Typography></TableCell>
                                        </TableRow>
                                    </Table>
                                </Grid>
                            </Grid>
                        </Card>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                            <Typography fontWeight="bold">Compensating Factors</Typography>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: "#C5DDFF" }} mt={1} p={1}>
                            <Typography color="#0F0396" fontWeight="bold" >Credit Analysis</Typography>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                            <Table sx={{ width: "100%" }} aria-label="simple table" size="small">
                                <TableRow>
                                    <TableCell scope="row" sx={{ borderBottom: "1px solid #9B9393" }}>High Credit Scores</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" sx={{ borderBottom: "1px solid #9B9393" }}>Low Inquiry</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" sx={{ borderBottom: "1px solid #9B9393" }}>Count No Derogatory Remarks {"<"} 1 No</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" sx={{ borderBottom: "1px solid #9B9393" }}>Bankruptcy</TableCell>
                                </TableRow>
                            </Table>

                        </Grid>
                        {data.eligible === true ? 
                            <>
                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: "#C5DDFF" }} mt={2} p={1}>
                                    <Typography color="#0F0396" fontWeight="bold">Remarks</Typography>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                    <Typography>Ready For Funding. Complete Recommendations</Typography>
                                </Grid>
                            </>
                            :
                            <></>
                        }
                    </Box>
                </Container>
            </Box>
            <Divider style={{ backgroundColor: "black" }} />
           
                <Grid container item lg={12} md={12} sm={12} xs={12}
                    sx={{backgroundColor: "#E5F0FF",}} mt={1}>
                    <Container minWidth={(isMobile && !showLogo) ? "100%" : 360} maxWidth={(isMobile && !showLogo) ? "100%" : 1600}>
                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={3} sx={{ padding: isMobile ? "2%" : "1% 5% 1% 5%",}} >
                        <Grid item lg={!showLogo ? 12 : 9} md={!showLogo ? 12 : 9} sm={12} xs={12}
                        sx={{display: "flex",justifyContent: !showLogo ? "center":"flex-start",flexDirection: "column",}}>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Typography fontWeight="bold">Disclaimer: </Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="body2">Funding eligibility is determined solely by third-party funding providers, based on their criteria. We do not guarantee approval or funding. MyFreeScoreNow is not liable for decisions made by third parties and encourage independent verification of terms and conditions before proceeding with any funding arrangements. </Typography>
                            </Grid>
                        </Grid>
                        {/* <Grid item lg={5} md={5} sm={12} xs={12}> */}
                            {/* <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Typography fontWeight="bold">Third-Party Evaluation</Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Typography variant="body2">Eligibility determinations are based on criteria set by the third-party funding provider, which may include, but are not limited to, creditworthiness, financial history, business performance, and other proprietary metrics.</Typography>
                            </Grid> */}
                        {/* </Grid> */}
                        {showLogo &&
                            <Grid item lg={3} md={3} sm={12} xs={12} sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: isMobile ? "center" : "flex-end"
                            }}>
                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: isMobile ? "center" : "right" }}>
                                    <img alt="#" src={advisorhub} style={{ height: isMobile ? "50px" : "80px" }} />
                                </Grid>
                            </Grid>
                        }
                        </Grid>
                    </Container>
                </Grid>
                </>
            :

              error?
            <Box sx={{height:'100vh',display:'flex'}}>
            <Grid item lg={12} md={12} sm={12} xs={12} sx={{display:'flex',justifyContent:'center',margin:'auto'}}>
                <Card variant="outlined" size="lg" sx={{textAlign:'center'}}>
                <CardContent>
                <Grid>
                <ErrorOutlineIcon color="error"  sx={{fontSize:'6vw'}}/>
                    <Typography variant="h2" sx={{color:'orange'}}>
                        Error
                    </Typography>
                    <Typography variant="h4">{error}</Typography>
                </Grid>
                
                </CardContent> </Card>
                </Grid>
            </Box>
            : null
                }

            {/* loader code start */}
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
            {/* loader code end */}

           
        </>

    );
}

export default FundingShotPdf;
